<template>
    <div>
        <div class="row">
            <div :class="['col_12', {'loading_overlay': loading}]">
                <div class="card no_border">
                    <div class="card-header">
                        <div class="card-title">{{ title }}</div>
                    </div>
                    <div class="card-body pl_0 pr_0">
                        <div class="d_flex_end form_action_btn">
                            <router-link class="btn btn_blue ml_10" :to="{name: cancelRouteName}">{{ $t('common.back') }}</router-link>
                        </div>
                        
                        <div class="row">
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('subject_id')}]">
                                    <label>{{ $t('common.subject') }}</label>
                                    <select v-model="form.subject_id" class="form_global">
                                        <option value="">{{ $t('common.select_subject') }}</option>
                                        <option :value="subject.id" v-for="subject in subjects" :key="'subject_'+subject.id">{{ subject.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('subject_id')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('grade_id')}]">
                                    <label>{{ $t('common.grade') }}</label>
                                    <select v-model="form.grade_id" class="form_global" @change="changeData()">
                                        <option value="">{{ $t('common.select_grade') }}</option>
                                        <option :value="grade.id" v-for="grade in grades" :key="'grade '+grade.id">{{ grade.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('grade_id')" />
                                </div>
                            </div>

                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('semester_id')}]">
                                    <label>{{ $t('common.semester') }}</label>
                                    <select v-model="form.semester_id" class="form_global" @change="changeData()">
                                        <option value="">{{ $t('common.select_semester') }}</option>
                                        <option :value="semester.id" v-for="semester in semesters" :key="'semester '+semester.id">{{ semester.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('semester_id')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('unit_id')}]">
                                    <label>{{ $t('common.unit') }}</label>
                                    <select v-model="form.unit_id" class="form_global">
                                        <option value="">{{ $t('common.select_unit') }}</option>
                                        <option :value="unit.id" v-for="unit in units" :key="'unit '+unit.id">{{ unit.unit_name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('unit_id')" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('learning_goal')}]">
                                    <label>{{ $t('sidebar.lectureCommon.learning_goal') }}</label>
                                    <input type="text" class="form_global" v-model="form.learning_goal">
                                    <v-errors :errors="errorFor('learning_goal')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('lecture_areas')}]">
                                    <label>{{ $t('common.area') }}</label>
                                    <Multiselect
                                        v-model="areas"
                                        mode="tags"
                                        :placeholder="$t('common.select_area')"
                                        :close-on-select="false"
                                        :searchable="true"
                                        :create-option="true"
                                        :hideSelected="false"
                                        :options="areaList"
                                    />
                                    <v-errors :errors="errorFor('lecture_areas')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('parking_id')}]">
                                    <label>{{ $t('common.parking') }}</label>
                                    <select v-model="form.parking_id" class="form_global">
                                        <option value="">{{ $t('common.select_parking') }}</option>
                                        <option :value="parking.id" v-for="parking in parkings" :key="'parking '+parking.id">{{ parking.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('parking_id')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('chapter_id')}]">
                                    <label>{{ $t('common.chapter') }}</label>
                                    <select v-model="form.chapter_id" class="form_global">
                                        <option value="">{{ $t('common.select_chapter') }}</option>
                                        <option :value="chapter.id" v-for="chapter in chapters" :key="'parking '+chapter.id">{{ chapter.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('chapter_id')" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <!-- <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('video_name')}]">
                                    <label>{{ $t('common.name') }}</label>
                                    <input type="text" class="form_global" v-model="form.video_name">
                                    <v-errors :errors="errorFor('video_name')" />
                                </div>
                            </div> -->
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('status')}]">
                                    <label>{{ $t('common.status') }}</label>
                                    <div class="form_inline">
                                        <div class="form_radio">
                                            <input type="radio" id="active" value="1" v-model="form.status">
                                            <label for="active">{{ $t('common.active') }}</label>
                                        </div>
                                        <div class="form_radio">
                                            <input type="radio" id="inactive" value="0" v-model="form.status">
                                            <label for="inactive">{{ $t('common.inactive') }}</label>
                                        </div>
                                    </div>
                                    <v-errors :errors="errorFor('status')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div class="form-group ">
                                    <label>{{ $t('sidebar.lectureCommon.lecture_image') }}</label>
                                    <input type="file" class="form_global" ref="lecture_image" @input="onFileChange($event)" accept="image/png, image/gif, image/jpeg, image/webp">
                                    <v-errors :errors="errorFor('lecture_image')"></v-errors>
                                </div>
                            </div>
                            <div class="col_1">
                                <div class="thumbnail_img" v-if="tempLectureImage || form.lecture_image">
                                    <div class="inner">
                                        <img v-if="tempLectureImage" :src="tempLectureImage" alt="" >
                                        <img v-else :src="form.lecture_image" alt="">
                                        <span class="close_icon" @click="removeTempLectureImage"></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col_12">
                                <div class="custom_tabs">
                                    <nav class="tabs">
                                        <ul class="">
                                            <li href="#video" class="active"> {{ $t('common.video') }} </li>
                                            <li href="#exams"> {{ $t('sidebar.exams.exams') }} </li>
                                        </ul>
                                    </nav>
                                    <div class="tab_content_wrapper">
                                        <div id="video" class="tab_content show">
                                            <div class="fadein">
                                                <div class="custom_tab_content_inner">
                                                    <div class="row">
                                                        <div class="col_12">
                                                            <div class="add_new d_flex_end">
                                                                <button class="btn btn_blue ml_20 width_150p" @click="openVideoUploadModal()"><i class="lni lni-plus"></i>{{ $t('common.add') }} {{ $t('common.video') }}</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row" v-if="lecture_preview_videos.length">
                                                        <div class="col_12">
                                                            <div class="video_list">
                                                                <div class="inner" v-for="(preview_video, index) in lecture_preview_videos" :key="index">
                                                                    <div class="inner_wrap" v-if="preview_video.convert_status">
                                                                        <img :src="preview_video.thumbs" alt="" v-if="preview_video.smil">
                                                                        <img :src="baseUrl + 'assets/images/no_image.jpg'" alt="" v-else>
                                                                        <div class="icons">
                                                                            <span v-if="preview_video.smil" @click.prevent="showVideo(preview_video.smil)"><i class="lni lni-eye"></i></span>
                                                                            <span><i class="lni lni-pencil" @click.prevent="editVideo(preview_video)"></i></span>
                                                                            <span><i class="lni lni-trash" @click.prevent="removeVideo(preview_video)"></i></span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="inner_wrap" v-else>
                                                                        <img :src="baseUrl + 'assets/images/no_image.jpg'" alt="">
                                                                        <div class="icons">
                                                                            <span><i class="lni lni-pencil" @click.prevent="editVideo(preview_video)"></i></span>
                                                                            <span><i class="lni lni-trash" @click.prevent="removeVideo(preview_video)"></i></span>
                                                                        </div>
                                                                    </div>
                                                                    <span class="video_type" v-if="preview_video.video_url">URL</span>
                                                                    <span class="video_type" v-else>Video</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="exams" class="tab_content">
                                            <div class="fadein">
                                                <div class="custom_tab_content_inner">
                                                    <div class="add_new d_flex_end">
                                                        <button class="btn btn_blue ml_20 width_150p" @click="openModalWithType('convergence_mathematics')"><i class="lni lni-plus"></i>{{ $t('sidebar.exams.add_exam') }}</button>
                                                    </div>
                                                    <div class="custom_tab_table">
                                                        <table class="table">
                                                            <tr>
                                                                <th>{{ $t('common.title') }}</th>
                                                                <th>{{ $t('sidebar.exams.exam_time') }}</th>
                                                                <th>
                                                                    <div class="d_flex_end">{{ $t('common.action') }}</div>
                                                                </th>
                                                            </tr>
                                                            <tr v-for="(exam, index) in selectedConvergenceMathematicsExams" :key="index">
                                                                <td>{{ exam.title }}</td>
                                                                <td>{{ exam.exam_time }} {{ $t('sidebar.lectureCommon.minute') }}</td>
                                                                <td>
                                                                    <div class="d_flex_end">
                                                                        <button class="btn btn_blue ml_10" @click="removeExam(exam.id)">
                                                                            <img :src="`${baseUrl}assets/media/images/icon/9.png`" alt="">
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <v-errors :errors="errorFor('exam_id')" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d_flex_end form_action_btn">
                            <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
                            <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <exam-modal v-if="openModal"
            :openModal="openModal" 
            :unit_id="form.unit_id"
            :subject_id="form.subject_id"
            :grade_id="form.grade_id"
            :semester_id="form.semester_id"
            :type="type"
            @convergenceExamData="convergenceExamData"
            @closeModal="closeModal">
        </exam-modal>

        <video-modal v-if="videoModalShow" :showVideoModal="videoModalShow" :video="videoSmilFile" @closeModal="closeModal()"></video-modal>

        <div class="modal" :class="{ 'open_modal': showVideoUploadModal}">
            <div class="modal_overlay"></div>
            <div class="modal_inner max_height_80">
                <div class="modal_header"> 
                    <span class="close_icon close_icon_sm" @click="closeModal()">×</span>
                </div>
                <div class="modal_wrapper">
                    <div class="modal_content modal_1080p">
                        <div class="container">
                            <div class="row">
                                <div :class="['col_12', {'d_none': isEditVideo}]">
                                    <div :class="['form-group', {'has_error': errorFor('upload_type')}]">
                                        <label>동영상 업로드 유형</label>
                                        <div class="form_inline">
                                            <div class="form_radio">
                                                <input type="radio" id="video_upload_type" value="1" v-model="video_upload_type">
                                                <label for="video_upload_type">{{ $t('common.video') }}</label>
                                            </div>
                                            <div class="form_radio">
                                                <input type="radio" id="url" value="2" v-model="video_upload_type">
                                                <label for="url">URL</label>
                                            </div>
                                        </div>
                                        <v-errors :errors="errorFor('upload_type')" />
                                    </div>
                                </div>
                                <div class="col_12" v-if="video_upload_type == 1">
                                    <div :class="['form-group', {'has_error': errorFor('lecture_videos')}]">
                                        <label>
                                            <h4>{{ $t('sidebar.lectureCommon.video') }}</h4>
                                        </label>
                                        <vue-dropzone ref="myVueDropzone" id="dropzone" :class="{'dropzone_disable' : dropzoneDisable}"
                                            @vdropzone-removed-file="vremoved"
                                            @vdropzone-success-multiple="vsuccessMuliple"
                                            :options="dropzoneOptions"
                                            :duplicateCheck="true">
                                        </vue-dropzone>

                                        <v-errors :errors="errorFor('lecture_videos')"></v-errors>
                                    </div>
                                </div>
                                <div class="col_12" v-if="video_upload_type == 2">
                                    <div :class="['form-group', {'has_error': errorFor('video_url')}]">
                                        <label>URL</label>
                                        <input type="text" class="form_global" v-model="temp_video_url">
                                        <v-errors :errors="errorFor('video_url')"></v-errors>
                                    </div>
                                </div>

                                <div class="col_12">
                                    <div :class="['form-group', {'has_error': errorFor('video_name')}]">
                                        <label>{{ $t('common.video_name') }}</label>
                                        <input type="text" class="form_global" v-model="form.video_name">
                                        <v-errors :errors="errorFor('video_name')" />
                                    </div>
                                </div>

                                <div class="col_12">
                                    <div :class="['form-group', {'has_error': errorFor('lecture_information')}]">
                                        <label>{{ $t('sidebar.lectureCommon.lecture_information') }}</label>
                                        <text-editor-component 
                                            :id="'lecture_information'" 
                                            :existingData="form.lecture_information ? form.lecture_information : ''" 
                                            @change="changeEditorValue"
                                        />
                                        <v-errors :errors="errorFor('lecture_information')" />
                                    </div>
                                </div>

                                <div class="col_12">
                                    <div class="d_flex_end">
                                        <button class="btn btn_blue ml_10 add_update" @click.prevent="addUploadVideo()">Add Video</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TextEditorComponent from "@/components/TextEditorComponent";
import Multiselect from '@vueform/multiselect'
import ExamModal from "../../components/ExamModal.vue";
import VideoModal from "../../components/VideoModal";
import vueDropzone from '../../components/dropzone';
export default {
  components: { Multiselect, TextEditorComponent, ExamModal, VideoModal, vueDropzone},
  data() {
    return {
        baseUrl: process.env.VUE_APP_BASE,
        title: this.$t('sidebar.holidayLecture.create_new_lecture'),
        cancelRouteName: 'holiday_convergence_mathematics_list',
        subjects: [],
        grades: [],
        semesters: [],
        parkings: [],
        chapters: [],
        units: [],
        areaList: [],
        form: {
            subject_id: '',
            grade_id: '',
            semester_id: '',
            parking_id: '',
            unit_id: '',
            chapter_id: '',
            page_number: '',
            status: 1,
            video_name: '',
            lecture_image: '',
            learning_goal: '',
            lecture_information: '',
            exam_id: [],
        },
        areas: [],
        selectedConvergenceMathematicsExams: [],
        selectedExams: [],
        convergenceExamRemoveableIds: [],
        openModal: false,
        type: '',
        examCheckEdAllStatus: false,
        lecture_video_url : [],
        lecture_videos : [],
        lecture_preview_videos : [],
        tempLectureImage : '',
        tempFile: null,
        videoSmilFile: null,
        videoModalShow: false,
        showVideoUploadModal: false,
        isUpload: false,
        dropzoneOptions: {
            url: `${process.env.VUE_APP_API_BASE_URL}/upload/video`,
            thumbnailWidth: 150,
            maxFiles: 1,
            maxFilesize: 5368709120,
            uploadMultiple: true,
            allowMultiple: true,
            addRemoveLinks: true,
            acceptedFiles: "video/*",
            headers: {
                "Authorization": `Bearer `+ JSON.parse(localStorage.getItem('admin')).token
            }
        },
        dropzoneDisable: false,
        video_upload_type: 1,
        isTempFile: false,
        temp_lecture_video: '',
        temp_lecture_original_video: '',
        temp_lecture_preview_video: '',
        temp_video_url: '',
        editValue : '',
        isEditVideo: false
    }
  },
  created() {
    this.axios.get('/subjects').then((response) => this.subjects = response.data.data);
    this.axios.get('/grades').then((response) => this.grades = response.data.data);
    this.axios.get('/semesters').then((response) => this.semesters = response.data.data);
    this.axios.get('/parkings').then((response) => this.parkings = response.data.data);

    this.axios.get('/areas')
        .then((response) => {
            let lectureArea  = response.data.data
            
            if(lectureArea){
                lectureArea.forEach((element) => {
                    let lectureAreaList = {
                        value: element.id,
                        label: element.name
                    }
                    this.areaList.push(lectureAreaList)
                });
            }
        })

    if (this.$route.name === 'holiday_convergence_mathematics_edit') {
      this.axios.get('/convergence-mathematics/'+this.$route.params.id)
        .then((response) => {
            let videoData = response.data.data;
            this.form.subject_id = videoData.subject ? videoData.subject.id : ''
            this.form.grade_id = videoData.grade ? videoData.grade.id : ''
            this.form.semester_id = videoData.semester ? videoData.semester.id : ''
            this.form.parking_id = videoData.parking ? videoData.parking.id : ''
            this.form.unit_id = videoData.unit ? videoData.unit.id : ''
            this.form.chapter_id = videoData.chapter ? videoData.chapter.id : ''
            this.form.page_number = videoData.page_number
            this.form.status = videoData.status
            this.form.video_name = videoData.video_name
            this.form.lecture_image = videoData.lecture_image
            this.form.learning_goal = videoData.learning_goal
            this.form.lecture_information = videoData.lecture_information

            this.editChangeData();

            if(videoData.areas){
                let areaData = [];
                videoData.areas.forEach(element => {
                    areaData.push(element.area_id)
                });

                this.areas = areaData
            }

            if(videoData.convergence_mathematics){
                let convergenceMathematicsExamData = [];
                videoData.convergence_mathematics.forEach(element => {
                    if(element.exam){
                        convergenceMathematicsExamData.push(element.exam)
                    }
                });

                this.selectedConvergenceMathematicsExams = convergenceMathematicsExamData
            }

            let lectureVideoList  = videoData.lectureVideos

            this.lecture_preview_videos = lectureVideoList
            if(this.lecture_preview_videos.length >= 1){
                this.dropzoneDisable = true
            }
            
            lectureVideoList.forEach((element) => {
                if(element.video_url){
                    let lectureUrlVideo = {
                        video_url: element.video_url,
                        lecture_information: element.lecture_information,
                        video_name: element.video_name,
                    }
                    this.lecture_video_url.push(lectureUrlVideo)
                }

                if(element.video_url == null){
                    let lectureOriginalFile = {
                        file: element.filename,
                        original_file: element.original_filename,
                        lecture_information: element.lecture_information,
                        video_name: element.video_name,
                    }
                    this.lecture_videos.push(lectureOriginalFile)
                }
            });
        })
      this.title = this.$t('sidebar.holidayLecture.edit_lecture');
    }
  },
  watch:{
    examCheckEdAllStatus:function(){
        if(this.examCheckEdAllStatus){
            this.convergenceExamRemoveableIds = this.selectedConvergenceMathematicsExams.map((i)=>i.id)
        }else{
            this.convergenceExamRemoveableIds = []
        }
    }
  },
  methods: {
    changeEditorValue(editorId, data){
      this.form[editorId] = data
    },
    onFileChange(e){
      this.form.lecture_image = e.target.files[0]
      this.tempLectureImage = URL.createObjectURL(e.target.files[0]);
    },
    removeTempLectureImage(){
      this.tempLectureImage = ''
      this.form.lecture_image = ''
      this.$refs.lecture_image.value = null;
    },
    vremoved(file) {
        if(!this.isTempFile){
            let index = this.lecture_videos.findIndex(object => { return object.original_file === file.name; });
            if (index !== -1){
                this.lecture_videos.splice(index, 1);
            }

            this.temp_lecture_video = '';
            this.temp_lecture_original_video = '';
        }
    },
    vsuccessMuliple(file, response) {
        this.temp_lecture_video = file
        this.temp_lecture_original_video = response
        if (this.lecture_preview_videos.length >= 1){
            this.dropzoneDisable = true
        }else{
            this.dropzoneDisable = false
        }
    },
    openVideoUploadModal(){
        this.editValue = ''
        this.isEditVideo = false
        this.showVideoUploadModal = true
        this.form.lecture_information = ''
        this.form.video_name = ''
        this.video_upload_type = 1
        window.$('.add_update').text('Add Video');

        if (this.lecture_preview_videos.length >= 1){
            this.dropzoneDisable = true
        }else{
            this.dropzoneDisable = false
        }
    },
    removeExam(id){
        this.selectedExams = [];

        this.selectedExams = this.selectedConvergenceMathematicsExams

        var index = this.selectedExams.findIndex(object => { return object.id === id; });
        if (index !== -1)
            this.selectedExams.splice(index, 1);

        if(!this.selectedExams.length){
            this.examCheckEdAllStatus = false
        }
    },
    removeVideo(video){
        let videoId = video.id

        if(video.video_url){
            let lecturePreviewIndex = this.lecture_preview_videos.findIndex(object => { return object.video_url ==  video.video_url });

            if (lecturePreviewIndex > -1){
                this.lecture_preview_videos.splice(lecturePreviewIndex, 1);
            }

            let lectureVideoUrlIndex = this.lecture_video_url.findIndex(object => { return object.video_url === video.video_url });
            if (lectureVideoUrlIndex > -1){
                this.lecture_video_url.splice(lectureVideoUrlIndex, 1);
            }
        }else{
            if(video.file){
                let lecturePreviewIndex = this.lecture_preview_videos.findIndex(object => { return object.file === video.file });
            
                if (lecturePreviewIndex > -1){
                    this.lecture_preview_videos.splice(lecturePreviewIndex, 1);
                }

                let lectureVideoIndex = this.lecture_videos.findIndex(object => { return object.file === video.file });

                if (lectureVideoIndex > -1){
                    this.lecture_videos.splice(lectureVideoIndex, 1);
                }
            }else{
                let lecturePreviewIndex = this.lecture_preview_videos.findIndex(object => { return object.filename === video.filename });
            
                if (lecturePreviewIndex > -1){
                    this.lecture_preview_videos.splice(lecturePreviewIndex, 1);
                }

                let lectureVideoIndex = this.lecture_videos.findIndex(object => { return object.filename === video.filename });

                if (lectureVideoIndex > -1){
                    this.lecture_videos.splice(lectureVideoIndex, 1);
                }
            }
        }

        this.axios.post('/delete-lecture-video', { 'id' : videoId})
        .then(() => {
            this.showSuccessMsg('Video Removed Successfully!')
            if (this.lecture_preview_videos.length > 2){
                this.dropzoneDisable = true
            }else{
                this.dropzoneDisable = false
            }
        });
    },
    editVideo(video){
        if(video.video_url){
            this.video_upload_type = 2
            this.temp_video_url = video.video_url
            this.editValue = video.video_url
        }else{
            if(video.file){
                this.editValue = video.file
            }else{
                this.editValue = video.filename
            }
            
            this.video_upload_type = 1
            this.dropzoneDisable = false
        }
        this.form.lecture_information = video.lecture_information
        this.form.video_name = video.video_name
        window.$('.add_update').text('Update Video');
        this.isEditVideo = true
        this.showVideoUploadModal = true
    },
    addUploadVideo(){
        if(this.video_upload_type == 1){
            if(this.isEditVideo){
                if(this.temp_lecture_video && this.temp_lecture_video.length){
                    let tempVideo = this.temp_lecture_video[0];
                    let tempVideoName = this.temp_lecture_original_video[0];

                    let lecturePreview = this.lecture_preview_videos.find(object => { return object.filename === this.editValue});

                    if(lecturePreview){
                        lecturePreview.file = tempVideoName.original_filename
                        lecturePreview.original_file = tempVideo.name
                        lecturePreview.lecture_information = this.form.lecture_information
                        lecturePreview.video_name = this.form.video_name
                    }

                    let lectureVideo = this.lecture_videos.find(object => { return object.file === this.editValue});

                    let prevoiousFileName = this.editValue;

                    if(lectureVideo){
                        lectureVideo.file = tempVideoName.original_filename
                        lectureVideo.original_file = tempVideo.name
                        lectureVideo.lecture_information = this.form.lecture_information
                        lectureVideo.video_name = this.form.video_name
                        lectureVideo.previous_filename = prevoiousFileName
                    }

                    this.isTempFile = true
                    this.$refs.myVueDropzone.removeFile(tempVideo)
                    this.temp_lecture_video = '';
                    this.temp_lecture_original_video = '';
                }else{
                    let lecturePreview = this.lecture_preview_videos.find(object => { return object.filename === this.editValue});
                    if(lecturePreview){
                        lecturePreview.lecture_information = this.form.lecture_information
                        lecturePreview.video_name = this.form.video_name
                    }

                    let lectureVideo = this.lecture_videos.find(object => { return object.file === this.editValue});
                    if(lectureVideo){
                        lectureVideo.lecture_information = this.form.lecture_information
                        lectureVideo.video_name = this.form.video_name
                    }
                }
            }else{
                if(this.temp_lecture_video && this.temp_lecture_video.length){
                    let tempVideo = this.temp_lecture_video[0];
                    let tempVideoName = this.temp_lecture_original_video[0];

                    let lectureOriginalFile = {
                        file: tempVideoName.original_filename,
                        original_file: tempVideo.name,
                        lecture_information: this.form.lecture_information,
                        video_name: this.form.video_name
                    }
                    
                    this.lecture_videos.push(lectureOriginalFile)
                    this.temp_lecture_preview_video = lectureOriginalFile

                    this.isTempFile = true
                    this.$refs.myVueDropzone.removeFile(tempVideo)
                    this.lecture_preview_videos.push(this.temp_lecture_preview_video)
                    this.temp_lecture_video = '';
                    this.temp_lecture_original_video = '';
                }
            }
        }else{
            if(this.isEditVideo){
                if(this.temp_video_url){
                    let url = this.temp_video_url;
                    let singleUrl = url.split(',');
                    if(singleUrl[0]){
                        let lecturePreview = this.lecture_preview_videos.find(object => { return object.video_url === this.editValue});
                        
                        if(lecturePreview){
                            lecturePreview.lecture_information = this.form.lecture_information
                            lecturePreview.video_name = this.form.video_name
                            lecturePreview.video_url = singleUrl[0]
                        }

                        let lectureVideoUrl = this.lecture_video_url.find(object => { return object.video_url === this.editValue});
                        
                        let previous_url = this.editValue

                        if(lectureVideoUrl){
                            lectureVideoUrl.lecture_information = this.form.lecture_information
                            lectureVideoUrl.video_name = this.form.video_name
                            lectureVideoUrl.video_url = singleUrl[0]
                            lectureVideoUrl.previous_url = previous_url
                        }
                    }else{
                        let lecturePreview = this.lecture_preview_videos.find(object => { return object.video_url === this.editValue});
                        
                        if(lecturePreview){
                            lecturePreview.lecture_information = this.form.lecture_information
                            lecturePreview.video_name = this.form.video_name
                        }

                        let lectureVideoUrl = this.lecture_video_url.find(object => { return object.video_url === this.editValue});
                        
                        if(lectureVideoUrl){
                            lectureVideoUrl.lecture_information = this.form.lecture_information
                            lectureVideoUrl.video_name = this.form.video_name
                        }
                    }
                }else{
                    let lecturePreview = this.lecture_preview_videos.find(object => { return object.video_url === this.editValue});
                        
                    if(lecturePreview){
                        lecturePreview.lecture_information = this.form.lecture_information
                        lecturePreview.video_name = this.form.video_name
                    }

                    let lectureVideoUrl = this.lecture_video_url.find(object => { return object.video_url === this.editValue});
                    
                    if(lectureVideoUrl){
                        lectureVideoUrl.lecture_information = this.form.lecture_information
                        lectureVideoUrl.video_name = this.form.video_name
                    }
                }
            }else{
                if(this.lecture_preview_videos.length < 1){

                    if(this.temp_video_url){
                        let url = this.temp_video_url;
                        let singleUrl = url.split(',');

                        if(singleUrl[0]){
                            let lectureUrlVideo = {
                                video_url: singleUrl[0],
                                lecture_information: this.form.lecture_information,
                                video_name: this.form.video_name
                            }

                            this.lecture_preview_videos.push(lectureUrlVideo)
                            this.lecture_video_url.push(lectureUrlVideo);
                        }
                    }
                }
            }
        }
        this.showVideoUploadModal = false
        this.temp_video_url = ''
        this.form.lecture_information = ''
        this.form.video_name = ''
    },
    openModalWithType(type){
        this.type = type
        this.openModal = true
    },
    convergenceExamData(data){
        if(data.length){
            this.selectedConvergenceMathematicsExams = data
        }
    },
    closeModal(){
        this.openModal = false
        this.videoModalShow = false
        this.showVideoUploadModal = false
        this.temp_video_url = ''
        this.form.lecture_information = ''
        this.form.video_name = ''
    },
    showVideo(smil){
        this.videoSmilFile = smil
        this.videoModalShow = true
    },
    changeData(){
      let grade_id = this.form.grade_id

      if(grade_id == ''){
        this.units = []
        this.form.unit_id = ''
        this.chapters = []
        this.form.chapter_id = ''
      }

      let semester_id = this.form.semester_id

      if(semester_id == ''){
        this.form.unit_id = ''
        this.units = []
        this.chapters = []
        this.form.chapter_id = ''
      }

      if(grade_id && semester_id){
          this.units = []
          this.form.unit_id = ''
          this.chapters = []
          this.form.chapter_id = ''
          this.axios.post('/load-unit-data/', {'grade_id': grade_id, 'semester_id': semester_id})
              .then((response) => {
                  let unitData = response.data.data
                  this.units = unitData
                  if(unitData && unitData.length < 1){
                      this.form.unit_id = ''
                      this.units = []
                  }
              })

          this.axios.post('/load-chapter-data/', {'grade_id': grade_id, 'semester_id': semester_id})
              .then((response) => {
                  let chapterData = response.data.data
                  this.chapters = chapterData
                  if(chapterData && chapterData.length < 1){
                      this.form.chapter_id = ''
                      this.chapters = []
                  }
              })
      }
    },
    editChangeData(){
      let grade_id = this.form.grade_id

      if(grade_id == ''){
        this.units = []
        this.form.unit_id = ''
        this.chapters = []
        this.form.chapter_id = ''
      }

      let semester_id = this.form.semester_id

      if(semester_id == ''){
        this.units = []
        this.form.unit_id = ''
        this.chapters = []
        this.form.chapter_id = ''
      }

      if(grade_id && semester_id){
          this.axios.post('/load-unit-data/', {'grade_id': grade_id, 'semester_id': semester_id})
            .then((response) => {
                let unitData = response.data.data
                this.units = unitData
                if(unitData && unitData.length < 1){
                    this.form.unit_id = ''
                    this.units = ''
                }
            })

          this.axios.post('/load-chapter-data/', {'grade_id': grade_id, 'semester_id': semester_id})
            .then((response) => {
                let chapterData = response.data.data
                this.chapters = chapterData
                if(chapterData && chapterData.length < 1){
                    this.form.chapter_id = ''
                    this.chapters = ''
                }
            })
      }
    },
    submit() {
        if(this.isUpload){
            this.showFailMsg('비디오 업로드가 아직 완료되지 않았습니다.')
            return;
        }
        this.allErrors = null;
        this.loading = true;
            
        if(this.selectedConvergenceMathematicsExams){
            this.form.exam_id = this.selectedConvergenceMathematicsExams.map(exam => exam.id)
        }

        if (this.$route.name === 'holiday_convergence_mathematics_edit') {
            this.loading = true;
            this.errors = null;

            let formData = new FormData();

            Object.keys(this.form).forEach(key => {
                formData.append(key, this.form[key] ? this.form[key] : '');
            })

            formData.append('lecture_areas', JSON.stringify(this.areas))
            formData.append('lecture_status', JSON.stringify(this.form.status))
            formData.append('lecture_videos', JSON.stringify(this.lecture_videos))
            formData.append('lecture_video_url', JSON.stringify(this.lecture_video_url))

            formData.append('_method','PATCH')

            this.axios.post('/convergence-mathematics/'+this.$route.params.id, formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            })
            .then(() => {
                this.$router.push({name: 'holiday_convergence_mathematics_list'});
                this.showSuccessMsg(this.$t('common.updateSuccess'))
            })
            .catch((err) => {
                this.allErrors = err.response.data.errors;
            })
            .finally(() => {
                this.loading = false;
            });
        } else {
            let formData = new FormData()

            Object.keys(this.form).forEach(key => {
                formData.append(key, this.form[key] ? this.form[key] : '');
            })

            formData.append('lecture_areas', JSON.stringify(this.areas))
            formData.append('lecture_status', JSON.stringify(this.form.status))
            formData.append('lecture_videos', JSON.stringify(this.lecture_videos))
            formData.append('lecture_video_url', JSON.stringify(this.lecture_video_url))

            this.axios.post('/convergence-mathematics/', formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            })
            .then(() => {
                this.$router.push({name: 'holiday_convergence_mathematics_list'});
                this.showSuccessMsg(this.$t('common.addSuccess'))
            })
            .catch((err) => {
                this.allErrors = err.response.data.errors;
            })
            .finally(() => {
                this.loading = false;
            });
        }
    },
  }
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.active {
    color: #78CB5B;
}

.inactive {
    color: #fff000;
}

.fa.fa-circle:before {
    content: "\25C9";
    /*color: #000;*/
}

th {
    text-align: center;
}

td:nth-child(1) {
    text-align: center;
}

td:nth-child(3) {
    text-align: center;
}

td:nth-child(2) {
    padding-left: 40px;
}

.event-active {
    font-weight: bold;
    color: #78CB5B;
    text-transform: uppercase;
    letter-spacing: 1.2px;
}
.dropzone_disable {
    pointer-events: none;
    cursor: default;
}
.dropzone_disable .dropzone .dz-message{
    display: none !important;
}
.video_list .video_type{
    text-align: center !important;
    display: block;
}
</style>
